import React, { useRef } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import { useGLTF, Stage,OrbitControls } from '@react-three/drei';
import './view3donly.css';

function Model(props) {
  const { scene } = useGLTF("/media/view3D/final/Blouse princesscut.glb");
  const model = useRef();

  useFrame(() => {
    if (model.current) {
      model.current.rotation.y += 0.015; // Adjust rotation speed as needed
    }
  });

  return <primitive object={scene} {...props} ref={model} />;
}

export default function Blouse3D() {
  return (
      <div className="view-header" style={{marginTop:"30px"}}>
       <Canvas>
      <OrbitControls
       enablePan={true}
            enableZoom={true}
            enableRotate={false} />
        <Stage>
          <Model scale={9.1} />
        </Stage>
      </Canvas>
      </div> 
  );
}
